import actions from '../actions-list';

export const updateModalVisibility = (isVisible) => (dispatch) => {

    dispatch({
        isVisible,
        type: actions.UPDATE_MODAL_VISIBILITY,
    });

};
